import useWidth from '../../../../Hooks/useWidth';
import HideColumnsV2Dialog from './components/HideColumnsV2Dialog/HideColumnsV2Dialog';
import HideColumnsV2Popover from './components/HideColumnsV2Popover/HideColumnsV2Popover';
import { HideColumnsV2WrapperProps } from './hideColumnsV2Wrapper.types';

const HideColumnsV2Wrapper = ({
  anchorEl,
  children,
  isOpen,
  onClose,
}: HideColumnsV2WrapperProps) => {
  const { mobileWidth } = useWidth();

  if (mobileWidth) {
    return <HideColumnsV2Dialog isOpen={isOpen}>{children}</HideColumnsV2Dialog>;
  }

  return (
    <HideColumnsV2Popover anchorEl={anchorEl} isOpen={isOpen} onClose={onClose}>
      {children}
    </HideColumnsV2Popover>
  );
};

export default HideColumnsV2Wrapper;
